import React, {useState, useEffect} from 'react'
import AdminTable from 'common/AdminTable'
import { toast } from 'react-toastify'
import { getRequest, deleteRequest } from 'apis/ApiInstence'


 const UsersList = () => {
    const [cartData, setCartData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [currentProduct, setCurrentProduct] = useState(null);


    const getusers = async () => {
        try {
            const response = await getRequest('users');
            console.log(response.data);
            if (response.status === 200) {
                setCartData(response);
            } else {
                toast.error('Failed to fetch users');
            }
        } catch (error) {
            toast.error(error.message || 'Failed to fetch users');
        }
    }
    useEffect(() => {
        getusers()
    }, []);

    // const handleEditClick = (product) => {
    //     setCurrentProduct(product);
    //     setShowModal(true);
    // };

    // Close the modal and reset state
    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentProduct(null);
        setImageFile(null);
    };

    // Handle saving the edited product
    // const handleSave = () => {
    //     const formData = new FormData();
    //     formData.append('id', currentProduct.id);
    //     formData.append('name', currentProduct.name);
    //     formData.append('sdate', currentProduct.sdate);
    //     formData.append('edate', currentProduct.edate);
    //     formData.append('long_description', currentProduct.long_description);
    //     formData.append('is_active', currentProduct.is_active);

    //     // If a new image is uploaded, append it to the formData
    //     if (imageFile) {
    //         formData.append('image', imageFile);
    //     }
    //     // Dispatch updateProduct with the formData
    //     dispatch(updateProduct({ id: currentProduct.id, data: formData }));
    //     toast('Game Updated Successfully!')
    //     handleCloseModal(); // Close modal after saving
    // };

    // const handleRemove = (id) => {
    //     Swal.fire({
    //         title: "Are you sure?",
    //         text: "You won't be able to revert this!",
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#d33",
    //         cancelButtonColor: "#3085d6",
    //         confirmButtonText: "Yes, delete it!",
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             dispatch(removeProduct(id));
    //             Swal.fire("Deleted!", "The product has been removed.", "success");
    //         }
    //     });
    // };

    // Handle image file selection
    // const handleImageChange = (event) => {
    //     setImageFile(event.target.files[0]);
    // };

    const handleDeleteClick = async (id) => {
        if (window.confirm("Are you sure you want to delete this user?")) {
            try {
                await deleteRequest(`users/${id}`);
                toast.success("User Deleted Successfully!");
                getusers();
            } catch (err) {
                toast.error("Failed to delete user");
                console.error(err);
            }
        }
    };

    // Table Headers
    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Username',
            accessor: 'username',
        },
        {
            Header: 'Date',
            accessor: 'createdAt',
        },
        {
            Header: 'Active',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <span className={row.original.is_active ? 'badge badge-success' : 'badge badge-danger'}>
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            Header: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <button className="btn btn-danger btn-sm text-white font-weight-bold" onClick={() => handleDeleteClick(row.original.id)}>
                    <i className="fa fa-trash"></i> Delete
                </button>
            ),
        }
    ];

    return (
        <>
            <div className="container-fluid mt-5 ">
                <div className="mainheadig mx-4">
                    <h4 className="text-white font-weight-bold">Users List</h4>
                </div>
                {cartData?.data?.length > 0 && (
                    <AdminTable tableHeaders={tableHeaders} tableData={cartData.data} />
                )}
            </div>

            {/* Edit Modal */}
            {showModal && currentProduct && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="editModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="editModalLabel">Edit Game</h5>
                                <button type="button" className="close" onClick={handleCloseModal} aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="form-group">
                                        <label htmlFor="productName">Status</label>
                                        <select defaultValue={currentProduct.is_active} onChange={(e) => setCurrentProduct({ ...currentProduct, is_active: e.target.value })} className="form-control" id="productStatus">
                                            <option value={true}>Active</option>
                                            <option value={false}>Inactive</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="productName">Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="productName"
                                            value={currentProduct.name}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, name: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="productPrice">Open Date</label>
                                        <input
                                            type="time"
                                            className="form-control"
                                            id="productPrice"
                                            value={currentProduct.sdate}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, sdate: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="productQuantity">Close Date</label>
                                        <input
                                            type="time"
                                            className="form-control"
                                            id="productQuantity"
                                            value={currentProduct.edate}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, edate: e.target.value })}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="productDescription">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="productDescription"
                                            value={currentProduct.long_description}
                                            onChange={(e) => setCurrentProduct({ ...currentProduct, long_description: e.target.value })}
                                        />
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={handleSave}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
export default UsersList;
